import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4zc36e4kj9: FaireBrandEntity = {
  token: "b_4zc36e4kj9",
  type: "brand",
  name: "Mia Accessories",
  avatarUrl:
    "https://cdn.faire.com/fastly/fbe019739b9230d2fe5c6c032809ebe8fe6d7fa6d871b907954ca1a37f9134e3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fbe44fcd818f07901f0d65507f04deb1a2112f2a2bdf25b2b77b8e3be6ad1692.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fbe019739b9230d2fe5c6c032809ebe8fe6d7fa6d871b907954ca1a37f9134e3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fbe44fcd818f07901f0d65507f04deb1a2112f2a2bdf25b2b77b8e3be6ad1692.jpeg",
  location: "SUGAR LAND, TX, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 27,
  isInsider: true,
  description:
    "Mia Accessories is a woman-owned wholesale jewelry brand founded by a proud Asian-American entrepreneur, built on a belief that great style should feel accessible, effortless, and empowering.\n\nWhat started as a dream in a small workspace has grown into a trusted wholesale partner for boutiques and retailers across the United States. Today, we specialize in high-quality, trend-forward fashion jewelry and stainless steel accessories designed to help your store stay fresh, profitable, and customer-loved.\n\nBased in Texas, USA, we’re proud to serve as a local wholesale supplier that understands what small businesses need most—reliable inventory, honest pricing, and styles that move quickly on the shelf.\n\nAt Mia Accessories, we’re committed to:\n\nQuality without compromise – premium-looking pieces at boutique-friendly price points\n\nTrend-driven collections – refreshed regularly to keep you ahead of the season\n\nTrue partnership – responsive service, dependable shipping, and long-term support\n\nWe’re not just here to sell jewelry—we’re here to help you grow your business with products your customers will come back for.\n\nWelcome to Mia Accessories. Let’s grow together.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:15.920Z",
    importedBy: "entity-db-cli",
  },
};
